import { openDB } from "idb";

// Definicija tipova podataka
interface Grupa {
    GrupaSifra: number;
    Naziv: string;
    Opis: string;
    Sortiranje: number;
    Roditelj: string;
}

interface GrupaRoba {
    GrupaSifra: string;
    RobaSifra: string;
}

// Inicijalizacija IndexedDB baze
export const initDB = async () => {
    return openDB("ERPDatabase", 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains("grupe")) {
                db.createObjectStore("grupe", { keyPath: "GrupaSifra" });
            }
            if (!db.objectStoreNames.contains("grupa_roba")) {
                db.createObjectStore("grupa_roba", { keyPath: ["GrupaSifra", "RobaSifra"] });
            }
        },
    });
};

// Spremanje grupa u IndexedDB
export const saveGrupe = async (grupe: Grupa[]) => {
    const db = await initDB();
    const tx = db.transaction("grupe", "readwrite");
    const store = tx.objectStore("grupe");
    grupe.forEach((grupa) => store.put(grupa));
    await tx.done;
};

// Dohvaćanje svih grupa
export const getGrupe = async (): Promise<Grupa[]> => {
    const db = await initDB();
    return db.getAll("grupe");
};

// Spremanje poveznica između grupa i robe
export const saveGrupaRoba = async (grupaRoba: GrupaRoba[]) => {
    const db = await initDB();
    const tx = db.transaction("grupa_roba", "readwrite");
    const store = tx.objectStore("grupa_roba");
    grupaRoba.forEach((relation) => store.put(relation));
    await tx.done;
};

// Dohvaćanje svih odnosa grupa-roba
export const getGrupaRoba = async (): Promise<GrupaRoba[]> => {
    const db = await initDB();
    return db.getAll("grupa_roba");
};
